import { graphql } from '../graphql/__generated__';
import { DiffFilter, DiffsOrderBy, DiffStatus } from './../graphql/__generated__/graphql';

export const BuildFrag = graphql(`
  fragment BuildFrag on Build {
    id
    name
    status
    error
    project
    approved: diffCountExtended(input: { status: APPROVED})
    approvedNew: diffCountExtended(input: { status: APPROVED, withBaseline: false })
    equal: diffCountExtended(input: { status: EQUAL})
    equalNew: diffCountExtended(input: { status: EQUAL, withBaseline: false })
    rejected: diffCountExtended(input: { status: REJECTED})
    rejectedNew: diffCountExtended(input: { status: REJECTED, withBaseline: false })
    unapproved: diffCountExtended(input: { status: UNAPPROVED})
    unapprovedNew: diffCountExtended(input: { status: UNAPPROVED, withBaseline: false })
    diffIds: diffs(filter: $filter) {
      nodes {
        id
      }
      totalCount
    }
  }
`);

export type DiffQueries = {
  order: DiffsOrderBy
}

export const filterDiffNotQueued = {
  status: {
    in: Object.values(DiffStatus).filter((value) => value !== DiffStatus.Queued),
  },
} as DiffFilter;
